import { render, staticRenderFns } from "./c_button.vue?vue&type=template&id=5564fccd&scoped=true"
import script from "./c_button.vue?vue&type=script&lang=js"
export * from "./c_button.vue?vue&type=script&lang=js"
import style0 from "./c_button.vue?vue&type=style&index=0&id=5564fccd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564fccd",
  null
  
)

export default component.exports